import React, { Component } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select from "react-select";
import axios from "axios";
import Cookies from "js-cookie";
import settings from "../../helpers/settings";
import AddCompany from "./addCompany";
import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Icon } from "@iconify/react";
import { IconButton } from '@mui/material';
// import MoreOptions from "./MoreOptions";
import { FormControl } from '@mui/material';
import AddEmployee from "./AddEmployee";
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import SELECT from '@mui/material/Select';
// import DepartmentManagment from "./AddDepartment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
let { KayanURL } = settings;
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  borderRadius: '20px',
  p: 4,
};
class UserManagment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      items: [],
      addNewCompanyPopUp: false,
      allCompanies: [],
      selectedCompanyEmployees: [],
      displayCompanyInfo: false,
      openEmployeePopUp: false,
      displayCompanyAfterUpdate: false,
    };
  }
  componentDidMount = async (e) => {
    this.getAllCompany();
  };
  getAllCompany = async (e) => {
    const result = await axios.put(
      KayanURL + "/test/company/getallCompanies",
      {
        apiToken: Cookies.get("Admin_Token"),
      }
    ); //try

    if (result) {
      let { data } = result;
      let options = [];
      if (data && data.success) {
        let { companies } = data;
        this.setState({
          allCompanies: companies,
          displayCompany: false,
        });
        if (this.state.displayCompanyAfterUpdate) {
          let selectedCompany = companies.filter((com) => {
            return com.id == this.state.selectedCompanyID;
          });
          this.setState({
            displayCompany: true,
            selectedCompany: selectedCompany[0]
          });
        }
        if (companies && companies.length > 0) {
          for (let i = 0; i < companies.length; i++) {
            options.push({
              value: companies[i].id,
              label: companies[i].name,
            });
          }
          this.setState({ options });
        } else {
          this.setState({ msgCompany: "There is No Company!" });
        }
      }
    }
  };
  onSelectValue = async (e) => {
    this.setState({
      selectedCompanyID: e.value,
    });

    let allCompanies = this.state.allCompanies;
    let selectedCompany = allCompanies.filter((com) => {
      return com.id == e.value;
    });

    if (selectedCompany && selectedCompany.length > 0) {
      // console.log(selectedCompany, "company")
      this.setState({
        selectedCompany: selectedCompany[0],
        displayCompany: true,

      });

      this.setState({ displayCompanyInfo: true, });
      this.getAllEmployees(selectedCompany[0].id)
    }
  };
  handleDeleteCompany = async (index) => {
    this.setState({
      deleteCompanyRequestSent: true,
      deleteCompanyResponse: false,
    });
    let response = await axios.put(
      KayanURL + "/test/company/deleteCompany",
      {
        id: index,
        apiToken: Cookies.get("Admin_Token"),
      }
    );

    if (response) {
      this.setState({
        deleteCompanyResponse: true,
        deleteCompanyRequestSent: false,
      });
      let { data } = response;
      if (data.success) {
        this.setState({ deleteCompanySelected: false });
        // window.location.reload(true);
        this.getAllCompany();
      } else {
        let { error } = data;
        if (error) {
          this.setState({ deleteCompanyError: error });
        }
      }
    }
  };
  handleUpdateCompany = async (element) => {
    this.setState({
      updateCompanyPopup: true
    })
    if (element) {
      this.setState({
        id: element.id,
        name: element.name,
        dhamaniID: element.dhamani_id,
        country: element.country,
        city: element.city,
        username: element.username,
      })
    }

  }
  updateCompanyHandleInputTextChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  UpdateCompany = async (e) => {
    e.preventDefault();
    const result = await axios.put(KayanURL + "/test/company/updateCompany", {
      data: {
        id: this.state.id,
        name: this.state.name,
        dhamaniID: this.state.dhamaniID,
        country: this.state.country,
        city: this.state.city,
        username: this.state.username,
      },
      apiToken: Cookies.get("Admin_Token"),
    });
    if (result.data.success) {
      this.setState({
        updatemessage: "updated Successfully !!!!",
        displayCompanyAfterUpdate: true,
        updateCompanyPopup: false,
      });
      this.getAllCompany();
    } else {
      this.setState({
        updatemessage: "Not updated,Please enter correct data!",
      });
    }
  };
  openAddNewCompanyModal = () => {
    this.setState({ openAddCompanyModal: true })
  }
  closeAddNewCompanyModal = () => {
    this.setState({ openAddCompanyModal: false })
    this.getAllCompany();
  }
  closeUpdateCompanyModal = () => {
    this.setState({ updateCompanyPopup: false, updatemessage: "" })
  }
  closeAddNewEmployeeModal = () => {
    this.setState({ openEmployeePopUp: false })
    this.getAllEmployees(this.state.selectedCompany.id)

  }
  getAllEmployees = async (companyId) => {
    const result = await axios.put(
      KayanURL + "/test/users/getUsers",
      {
        companyid: companyId,
        apiToken: Cookies.get("Admin_Token"),
      }
    );

    if (result) {
      let { data } = result;
      if (data && data.success) {
        this.setState({ AllEmployees: data.employees });
      } else {
        this.setState({ AllEmployees: data.employees });
      }
    }
  };
  handleDeleteEmployee = async (index) => {
    let response = await axios.put(
      KayanURL + "/test/users/deleteUser",
      {
        id: index,
        apiToken: Cookies.get("Admin_Token"),
      }
    );
    if (response) {
      let { data } = response;
      if (data.success) {
        this.setState({ success: "true" });
        this.getAllEmployees(this.state.selectedCompany.id);
      } else {
        let { error } = data;
        if (error) {
          this.setState({ success: false, deleteEmpyeeError: error });
        }
      }
    }
  };
  handleUpdateEmployee = async (element) => {
    let dataJsonValueForUpdate
    if (element) {
      dataJsonValueForUpdate = {
        id: element.id,
        name: element.name,
        username: element.username,

      }
      this.setState({ dataJsonValueForUpdate, updateEmployeeModal: true });
    }
  }
  closeUpdateEmployeeModal = () => {
    this.setState({ updateEmployeeModal: false })
    this.getAllEmployees(this.state.selectedCompany.id)
  }
  updateEmployeeHandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === 'name') {
      this.state.dataJsonValueForUpdate.name = value;
    } else if (name === 'username') {
      this.state.dataJsonValueForUpdate.username = value;
    }
    else if (name === 'password') {
      this.state.dataJsonValueForUpdate.password = value;
    }

  };
  UpdateEmployee = async (e) => {
    e.preventDefault();
    const result = await axios.put(KayanURL + "/test/users/updateUser", {
      data: this.state.dataJsonValueForUpdate,
      apiToken: Cookies.get("Admin_Token"),
    });
    if (result.data.success) {
      this.setState({
        updatemessage: "updated Successfully !!!!",
        updateEmployeeModal: false,
        dataJsonValueForUpdate: ""
      });
      this.getAllEmployees(this.state.selectedCompany.id);
    } else {
      this.setState({
        updatemessage: "Not updated,Please enter correct data!",
      });
    }
  };
  handleGenerateToken = async (user) => {
    Cookies.remove("apiToken");
    this.setState({userID:""});
    if (user) {
      const result = await axios.put(KayanURL + "/test/users/generateToken", {
        User: user,
      });
      if (result) {
        let { data } = result;
        if (data) {
          let { success, apiToken } = data;
          if (success) {
            Cookies.set("apiToken", apiToken);
            this.setState({userID:user.id});
            this.getAllEmployees(this.state.selectedCompany.id);
          } else {

          }
        }
      }
    }

  };
  render() {
    let { selectedCompany, AllEmployees } = this.state;
    let companyInfoRow, employeeRows
    if (selectedCompany) {
      companyInfoRow = (
        <TableRow
        >
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.name}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.dhamani_id}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.country}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.city}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.username}</TableCell>
          {selectedCompany.active ? <TableCell align="center" style={{ fontSize: "small" }}>Active</TableCell> : <TableCell align="center" style={{ fontSize: "small" }}>Not Active</TableCell>}
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.endedat}</TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>{selectedCompany.transactions}</TableCell>

          <TableCell align="center" style={{ fontSize: "small" }}>
            <div>
              <a
                style={{ cursor: "pointer", marginRight: "5px" }}
                onClick={() => this.handleUpdateCompany(selectedCompany)}
              >
                <EditIcon style={{ fontSize: "17px" }} />
              </a>
              <a
                style={{ cursor: "pointer" }}
                onClick={() => this.handleDeleteCompany(selectedCompany.id)}
              >
                <DeleteIcon style={{ fontSize: "17px" }} />
              </a>
            </div>
          </TableCell>
        </TableRow>
      );
    }
    if (AllEmployees && AllEmployees.length > 0) {
      employeeRows = AllEmployees.map((element, index) => {
        return (
          <TableRow key={index}
          >
            <TableCell align="center" style={{ fontSize: "small" }}>{element.name}</TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>{element.username}</TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <div>
                {Cookies.get("apiToken") && (this.state.userID === element.id) ? (
                  <>
                    {Cookies.get("apiToken")}
                  </>
                ) : (
                  <a
                    style={{ cursor: "pointer", marginRight: "5px", backgroundColor: "grey", padding: "7px", borderRadius: "5px", color: "white" }}
                    onClick={() => this.handleGenerateToken(element)}
                  >
                    Generate Token
                  </a>
                )}

              </div>
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <div>
                <a
                  style={{ cursor: "pointer", marginRight: "5px" }}
                  onClick={() => this.handleUpdateEmployee(element)}
                >
                  <EditIcon style={{ fontSize: "17px" }} />
                </a>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => this.handleDeleteEmployee(element.id)}
                >
                  <DeleteIcon style={{ fontSize: "17px" }} />
                </a>
              </div>
            </TableCell>
          </TableRow >
        )
      })
    }
    return (
      <>
        <Box height={60} />
        <div
          style={{
            textAlign: "left",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px"
          }}>
          <div
            style={{
              padding: "15px",
              width: "70%",
              margin: "auto"
            }}>
            <Select
              onChange={(e) => this.onSelectValue(e)}
              options={this.state.options}
              isSearchable="true"
            ></Select>
            <div style={{ textAlign: "center" }}>
              <a
                onClick={(e) => this.openAddNewCompanyModal(e)}
                style={{
                  color: "grey",
                  display: "inline-block",
                  marginTop: "5px",
                  fontWeight: "550",
                  textDecorationLine: "underline",
                  cursor: "pointer"
                }}
              >
                Add New Company
              </a>
            </div>
          </div>

          {this.state.openAddCompanyModal ? (
            <>
              <Modal
                open={this.state.openAddCompanyModal}
                onClose={this.closeAddNewCompanyModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box sx={styleModal} style={{
                  width: "50%",
                  height: "650px",
                  border: "1px solid white",
                }}>
                  <AddCompany closeAddNewCompanyModal={this.closeAddNewCompanyModal} />

                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.selectedCompanyID && selectedCompany && this.state.displayCompany ? (
            <div style={{ width: "90%", margin: "30px auto" }}>

              <TableContainer component={Paper} style={{ marginTop: "10px", width: "100%" }}>
                <Table aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                    <TableRow style={{ textAlign: 'center' }}>
                      <TableCell align="center">Company Name</TableCell>
                      <TableCell align="center">Dhamani ID</TableCell>
                      <TableCell align="center">Country</TableCell>
                      <TableCell align="center">City</TableCell>
                      <TableCell align="center">User Name</TableCell>
                      <TableCell align="center">Active Status</TableCell>
                      <TableCell align="center">Activation End Date</TableCell>
                      <TableCell align="center">Transactions</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {companyInfoRow}
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{ width: "22%", marginTop: "17px", marginRight: "auto" }}>
                <Button variant="primary" type="submit"
                  onClick={() =>
                    this.setState({
                      openEmployeePopUp: true,
                    })
                  }
                  style={{
                    width: "100%",
                    padding: "6px",
                    backgroundColor: "rgb(97 110 120"
                    , border: "1px solid rgb(97 110 120", color: "white"
                  }}>
                  Add New Employee
                </Button>
              </div>
              <div>
                <div style={{ textAlign: "center" }}>
                  <Typography variant="h6" component="div" >
                    Employees For {selectedCompany.name} Company:
                  </Typography>
                </div>
              </div>

              {AllEmployees && AllEmployees.length > 0 ? (<>
                <div style={{ width: "80%", margin: "30px auto" }}>
                  <TableContainer component={Paper} style={{ marginTop: "10px", width: "100%" }}>
                    <Table aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#fafafa" }}>
                        <TableRow style={{ textAlign: 'center' }}>
                          <TableCell align="center">Name</TableCell>
                          <TableCell align="center">User Name</TableCell>
                          <TableCell align="center">Generate Token</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {employeeRows}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </>) :
                <>
                  <Typography variant="h6" component="div" style={{ color: "red", fontSize: "13px", textAlign: "center" }}>
                    There is no Employees For This Company
                  </Typography>
                </>}
            </div>
          ) : null}

          {this.state.updateCompanyPopup ? (
            <>
              <Modal
                open={this.state.updateCompanyPopup}
                onClose={this.closeUpdateCompanyModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box sx={styleModal} style={{
                  width: "50%",
                  height: "500px",
                  overflowY: "scroll",
                  border: "1px solid white",
                }}>
                  <div style={{
                    width: "50%",
                    margin: "auto"
                  }}>
                    <FormControl fullWidth sx={{ mb: 3 }} >
                      <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                        inputProps={{ sx: { padding: "11px" } }} required
                        label="Company Name" variant="outlined"
                        name="name"
                        onChange={this.updateCompanyHandleInputTextChange}
                        defaultValue={this.state.name ? this.state.name : ""}
                      />
                    </FormControl>

                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        required name="dhamaniID"
                        type="text" label="Dhamani ID"
                        defaultValue={this.state.dhamaniID ? this.state.dhamaniID : ""}
                        variant="outlined" onChange={this.updateCompanyHandleInputTextChange}
                      />
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        name="country"
                        type="text" label="Country"
                        defaultValue={this.state.country ? this.state.country : ""}
                        variant="outlined" onChange={this.updateCompanyHandleInputTextChange}
                      />
                    </FormControl>

                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        name="city"
                        type="text" label="City"
                        defaultValue={this.state.city ? this.state.city : ""}
                        variant="outlined" onChange={this.updateCompanyHandleInputTextChange}
                      />
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        required name="username" label="User Name"
                        variant="outlined" onChange={this.updateCompanyHandleInputTextChange}
                        defaultValue={this.state.username ? this.state.username : ""}

                      />
                    </FormControl>
                  </div>

                  <div style={{ textAlign: "center" }}>
                    <Button variant="primary" type="submit"
                      onClick={(e) => this.UpdateCompany(e)}
                      style={{
                        width: "50%"
                        , marginTop: "10px"
                        , backgroundColor: "rgb(97 110 120"
                        , border: "1px solid rgb(97 110 120", color: "white"
                      }}>
                      Update
                    </Button>
                  </div>

                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.openEmployeePopUp ? (
            <>
              <Modal
                open={this.state.openEmployeePopUp}
                onClose={this.closeAddNewEmployeeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box sx={styleModal} style={{
                  width: "60%",
                  height: "470px",
                  overflowY: "scroll",
                  border: "1px solid white",
                }}>
                  <AddEmployee
                    companyId={selectedCompany.id}
                  />
                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.updateEmployeeModal ? (
            <>
              <Modal
                open={this.state.updateEmployeeModal}
                onClose={this.closeUpdateEmployeeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box sx={styleModal} style={{
                  width: "30%",
                  height: "300px",
                  overflowY: "scroll",
                  border: "1px solid white",
                }}>
                  <FormControl fullWidth sx={{ mb: 3 }} >
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }} required
                      label="Name" variant="outlined"
                      name="name"
                      onChange={this.updateEmployeeHandleInputTextChange}
                      defaultValue={this.state.dataJsonValueForUpdate.name ? this.state.dataJsonValueForUpdate.name : ""}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="username" label="User Name"
                      variant="outlined" onChange={this.updateEmployeeHandleInputTextChange}
                      defaultValue={this.state.dataJsonValueForUpdate.username ? this.state.dataJsonValueForUpdate.username : ""}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="password"
                      type="password" label="Password"
                      variant="outlined" onChange={this.updateEmployeeHandleInputTextChange}
                    />
                  </FormControl>
                  <div style={{ textAlign: "center" }}>
                    <Button variant="primary" type="submit"
                      onClick={(e) => this.UpdateEmployee(e)}
                      style={{
                        width: "50%"
                        , marginTop: "10px"
                        , backgroundColor: "rgb(97 110 120"
                        , border: "1px solid rgb(97 110 120", color: "white"
                      }}>
                      Update
                    </Button>
                  </div>
                </Box>
              </Modal>
            </>
          ) : null}

        </div>
      </>

    );
  }

}
export default UserManagment;
